import React from 'react';
import './AdImageModal.scss';
import {getImageUrl} from '../api/iposApi';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const AdImageModal = ({closeModal, onClose, onOk, imagePath}) => {

  const imageUrl = getImageUrl(imagePath, true);
  const onContentClick = () => {
    if (onOk) {
      onOk();
    }
    closeModal();
  };

  return (
    <div className="ad-image-modal-content" onClick={ onContentClick }>
     <img src={ imageUrl } alt="ad_image" />

      <div className={ 'close-btn' } onClick={ onContentClick }>
        <FontAwesomeIcon icon={ 'times' }  />
      </div>
    </div>
  );
};

export default AdImageModal;
